import Layout from 'components/Layout';
import React, { useState } from 'react';
import { Nav, TabContent, TabPane } from 'reactstrap';


import { TabItem } from '../components/tabItem';
import JourneyPageEditor from '../components/uuCafeJourney/JouneyPageEditor';
import JourneySettings from '../components/uuCafeJourney/JourneySettings';

const UUCafeJourney = () => {
  const [currentTab, setCurrentTab] = useState(1);
  return (
    <Layout
      pageTitle="關於我們"
      items={[
        { isActive: true, page_name: 'UUCafe' },
        { isActive: true, page_name: '關於我們' },
      ]}
    >
      <Nav pills className="mb-2">
        <TabItem
          onClick={setCurrentTab}
          tab={1}
          text="里程碑管理"
          currentTab={currentTab}
        />
        <TabItem
          onClick={setCurrentTab}
          tab={2}
          text="頁面設定"
          currentTab={currentTab}
        />
      </Nav>
      <TabContent activeTab={currentTab}>
        <TabPane tabId={1}>
          <JourneySettings />
        </TabPane>
        <TabPane tabId={2}>
          <JourneyPageEditor />
        </TabPane>
      </TabContent>
    </Layout>
  );
};

export default UUCafeJourney;
